const misParticipantsListPpuSchema = ({ data = {} }) => {
  return (
    <tr className='text-gray-600'>
      <td className='pl-3 pr-4 py-4' style={{width: '12%'}}>
        <p className='font-semibold mb-0 inline-block mr-2'>{data.customer_name}</p>
        {data.customer_active && <span className='px-2 inline-flex leading-6 font-semibold rounded-full bg-green-100 text-green-700'>Active</span>}
        <p className='mb-0'>{data.customer_email}</p>
      </td>

      <td className='pl-3 pr-4 py-4' style={{width: '13%'}}>
        <span>{data.appointment_date}</span>
        {data.appointment_status === 'completed' && <span className='px-2 ml-1 inline-flex leading-6 font-semibold rounded-full bg-green-100 text-green-700'>Completed</span>}
        <br />
        <span>ID - {data.appointment_id}</span>
      </td>

      <td className='pl-3 pr-4 py-4' style={{width: '13%'}}>
        <span>{data.provider_name}</span>
        <br />
        <span>{data.provider_city}</span>
      </td>

      <td className='pl-3 pr-4 py-4' style={{width: '12%'}}>
        <span>{data.package_name}</span>
        <br />
        <span>&#8377;{data.package_cost}</span>
      </td>

      <td className='pl-3 pr-4 py-4' style={{width: '13%'}}><span>{data.package_type}</span></td>
      <td className='pl-3 pr-4 py-4' style={{width: '7%'}}><span>{data.customer_type}</span></td>
      <td className='pl-3 pr-4 py-4' style={{width: '13%'}}><span>{data.customer_department}</span></td>
      <td className='pl-3 pr-4 py-4' style={{width: '10%'}}><span>{data.entity}</span></td>
      <td className='pl-3 pr-4 py-4' style={{width: '7%'}}><span>{data.mobile_number || 9087654321}</span></td>
    </tr>
  )
}

const misParticipantsListSubscriptionSchema = ({data = {}}) => {
  return (
    <tr className='text-gray-600'>
      <td className='pl-3 pr-4 py-4'>{data.employee_id}</td>
      <td className='pl-3 pr-4 py-4'>
        <p className='font-semibold mb-0 inline-block mr-2'>{data.customer_name}</p>
        <p className='mb-0'>{data.customer_email}</p>
      </td>
      <td className='pl-3 pr-4 py-4'>{data.customer_gender}</td>
      <td className='pl-3 pr-4 py-4'>{data.location}</td>
      <td className='pl-3 pr-4 py-4'>{data.customer_dob}</td>
      <td className='pl-3 pr-4 py-4'>{data.customer_department}</td>
      <td className='pl-3 pr-4 py-4'>{data.mobile_number}</td>
      <td className='pl-3 pr-4 py-4'>{data.vip ? 'Yes' : 'No'}</td>
      <td className='pl-3 pr-4 py-4'>{data.entity}</td>
    </tr>
  )
}

const misParticipantsListSchema = (service = '') => {
  service = service.toLowerCase()
  if(['health checks', 'vaccination', 'vision', 'dental', 'onsite', 'engagement activity', 'ohc'].includes(service)) return misParticipantsListPpuSchema
  else if(['doctor consultation', 'opd', 'ewap', 'smart cover', 'gym', 'employee addition', 'health coach'].includes(service)) return misParticipantsListSubscriptionSchema
  
  return (...rest) => {}
}

export default misParticipantsListSchema